import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {
  },
  staticActions: {},
  schema:  schema
};
